import * as React from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { AppWrapper } from "../containers";
import { Spinner } from "../components";
import { isAuthenticated } from "../common/utils";
import { userRoles } from "./util";
import NotAuthorizedPage from "../pages/notAuthorized";
import { Suspense } from "react";
import NotFound from "../pages/notFound";
export interface RoutesData {
  key: string;
  title: string;
  path: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  routes?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component?: any;
  showInMainNav?: string;
  exact?: boolean;
  authRequired?: boolean;
  roles?: string[];
}

// Allows for rendering nested Route components
export const RouteWithSubRoutes = (route: RoutesData) => {
  const { component: RouteComponent, routes, authRequired, roles } = route;
  const userRole: string = useSelector((state: any) => state.users.roleName);
  const dataFetched: boolean = useSelector((state: any) => state.users.dataFetched);
  const userName = userRoles.filter((user) => user.id == userRole)[0]
    ?.displayName;
  const isAuthorizedToAccessPage: Boolean = roles?.includes(userName);
  const navigate = useNavigate();
  const canAccess: Boolean = isAuthenticated();

  React.useEffect(() => {
    if (authRequired && !canAccess && isAuthorizedToAccessPage) {
      navigate('/', { replace: true });
    }
  }, [authRequired, canAccess]);
  if(!dataFetched)
    return null; 
  return authRequired === false || isAuthorizedToAccessPage ? (
    <RouteComponent routes={routes} />
  ) : (
    <NotAuthorizedPage />
  );
};

// Render route with sub routes
export const RootRouteComponentWithSubRoutes = ({
  routes,
}: {
  routes: RoutesData[];
}) => {
  return (
    <Routes>
      {routes?.map((route) => (
        <Route
          key={route.key}
          path={route.path}
          element={<RouteWithSubRoutes {...route} />}
        />
      ))}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

// Wrap Routes in AppWrapper (Can create any wrapper based on different requirement/layout like login, faq, etc)
export const RootAppComponentWithRoutes = ({
  routes,
}: {
  routes: RoutesData[];
}) => {
  return (
    <AppWrapper>
      <Suspense fallback={<Spinner isActive={true} />}>
        <RootRouteComponentWithSubRoutes routes={routes} />
      </Suspense>
    </AppWrapper>
  );
};
